import axios from 'axios';

export const fetchSettings = async (isLoggedIn = false) => {
	try {
		const targetEndpoint = isLoggedIn ? '/api/settings' : '/api/publicSettings';
		const response = await axios.get(targetEndpoint);
		return response.data ? response.data : null;
	} catch (error) {
		console.error('Error fetching settings:', error);
		return null;
	}
};
